






























import Vue from 'vue';
import {PropSync, Watch} from 'vue-property-decorator';
import {acceptedModule, challengesState, inProgressChallengesState} from '@/utils/store-acessor';
import {ChallengeModel} from '@/models/challenge.model';
import Component from 'vue-class-component';
import RequestStatus from '@/components/RequestStatus.vue';
import ChallengeCard from '@/components/ChallengeCard.vue';

@Component({
  components: {
    ChallengeCard,
    RequestStatus

  }
})
export default class ChallengeRelatedChallenges extends Vue {
  challenges: ChallengeModel[] = [];
  error: any = null;
  noRelated: boolean = false;
  @acceptedModule.Getter('userHasAccepted') userHasAccepted!: (challengeId: number) => boolean;
  @PropSync('id', {required: true, default: null})
  challengeId!: number | null;

  mounted() {
    this.onChallengeIdChange();
  }

  @Watch('challengeId')
  async onChallengeIdChange() {
    if (this.challengeId) {
      await inProgressChallengesState.fetchAll({page: 1});
      this.challenges = await inProgressChallengesState.getRelatedChallenges(this.challengeId);
      if (this.challenges.length < 1) {
        this.noRelated = true;
      }
    }
  }

  async openChallenge(slug: string) {
    this.$router.push({params: {slug}});
    await challengesState.getChallengeBySlug({slug});
  }
}
